/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    IBuyboxAddToWishlistViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxShopSimilarLookViewProps
} from '@msdyn365-commerce-modules/buybox';
import { IBuyboxViewProps } from './custom-buybox';
// import { IBuyboxFindInStoreViewProps } from './components/custom-buybox-find-in-store';

const BuyboxView: React.FC<IBuyboxViewProps> = props => {
    const {
        ModuleProps,
        MediaGalleryContainerProps,
        ProductInfoContainerProps,
        addToCart,
        addToOrderTemplate,
        addToWishlist,
        configure,
        description,
        // findInStore,
        quantity,
        title,
        rating,
        inventoryLabel,
        shopSimilarLook,
        keyInPrice,
        shopSimilarDescription,
        unitOfMeasure,
        productComparisonButton,
        productTypes
    } = props;

    return (
        <>
            <Module {...ModuleProps}>
                <Node {...MediaGalleryContainerProps}>{props.mediaGallery}</Node>
                <Node {...ProductInfoContainerProps}>
                    {title}
                    {unitOfMeasure}
                    {props.state.isFirstRender}
                    {props.bulkPurchaseLink}
                    {description}
                    {rating}
                    {configure && _renderConfigure(configure)}
                    {keyInPrice && _renderKeyInPrice(keyInPrice)}
                    {quantity && _renderQuantity(quantity)}
                    {quantity && _renderQuantityHelpText()}
                    {inventoryLabel}
                    {productTypes}
                    {addToCart && !props.state.isNoOptions && _renderAddToCart(addToCart)}
                    {/* {findInStore && _renderFindInStore(findInStore)} */}
                    {addToOrderTemplate && _renderAddToOrderTemplate(addToOrderTemplate)}
                    {addToWishlist && _renderAddToWishlist(addToWishlist)}
                    {_renderSocialShare(props.slots && props.slots.socialShare)}
                    {productComparisonButton}
                    {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                    {shopSimilarDescription && _renderShopSimilarItem(shopSimilarDescription)}
                    {props.rdaCustomHtml}
                </Node>
            </Module>
        </>
    );
};

const _renderQuantityHelpText = (): JSX.Element => {
    return <Node className=''>Subject to Availability</Node>;
};

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToCart;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToOrderTemplate = (addToOrderTemplate: IBuyboxAddToOrderTemplateViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToOrderTemplate;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToWishlist = (addToWishlist: IBuyboxAddToWishlistViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToWishlist;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;

    return <Node {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }

    return <>{socialShare[0]}</>;
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

// const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
//     const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;

//     return (
//         <Node {...ContainerProps}>
//             {storeSelector}
//             {heading}
//             {productPickupOptionList}
//             {description}
//             {errors}
//             {button}
//             {modal}
//         </Node>
//     );
// };

const _renderQuantity = (quantity: IBuyboxProductQuantityViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input, errors } = quantity;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {input}
        </Node>
    );
};

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>{heading}</Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};
export default BuyboxView;
